import { defineMessages } from 'react-intl';

export const sagaMessages = defineMessages({
  createDisabledTimeWindowSuccess: {
    id: 'venue-page.saga.do-create-disabled-time-window.success',
    defaultMessage: 'Successfully created closure dates',
  },
  createDisabledTimeWindowFailure: {
    id: 'venue-page.saga.do-create-disabled-time-window.failure',
    defaultMessage: 'We were unable to save your closure dates at this time',
  },
  deleteDisabledTimeWindowFailure: {
    id: 'venue-page.saga.do-delete-disabled-time-window.failure',
    defaultMessage: 'We were unable to delete your closure dates at this time',
  },
});

export const componentMessages = defineMessages({
  title: {
    id: 'venue-page.disabled-time-blocks.title',
    defaultMessage: 'Closed Dates',
  },
  description: {
    id: 'venue-page.disabled-time-blocks.description',
    defaultMessage:
      'List the dates your business is closed for public holidays, maintenance or any other reason. Members will not be able to place online bookings during these days. <strong>The maximum closure duration is 14 days.</strong>',
  },
  contactUs: {
    id: 'venue-page.disabled-time-blocks.contact-us',
    defaultMessage: '<a>Contact us</a> if you plan on closing your business for longer than 14 days.',
  },
  timeWindowRange: {
    id: 'venue-page.disabled-time-blocks.time-window-range',
    defaultMessage: '{startTime, date, medium-w-dow-time} - {endTime, date, medium-w-dow-time}',
  },
  timeWindowRangeDays: {
    id: 'venue-page.disabled-time-blocks.time-window-range-days',
    defaultMessage: '{startTime, date, medium-w-dow} - {endTime, date, medium-w-dow}',
  },
  add: {
    id: 'venue-page.disabled-time-blocks.add',
    defaultMessage: 'Add dates',
  },
  delete: {
    id: 'venue-page.disabled-time-blocks.delete',
    defaultMessage: 'Delete',
  },
  descriptionFieldLabel: {
    id: 'venue-page.disabled-time-blocks.description-field-label',
    defaultMessage: 'Description',
  },
  startTimeFieldLabel: {
    id: 'venue-page.disabled-time-blocks.start-time-field-label',
    defaultMessage: 'Start Time',
  },
  endTimeFieldLabel: {
    id: 'venue-page.disabled-time-blocks.end-time-field-label',
    defaultMessage: 'End Time',
  },
  cancelButtonLabel: {
    id: 'venue-page.disabled-time-blocks.cancel-button-label',
    defaultMessage: 'Cancel',
  },
  saveButtonLabel: {
    id: 'venue-page.disabled-time-blocks.save-button-label',
    defaultMessage: 'Save',
  },
  dateInPast: {
    id: 'venue-page.disabled-time-blocks.date-in-past',
    defaultMessage: 'Closure date cannot be in the past',
  },
  dateInExistingDisabledWindow: {
    id: 'venue-page.disabled-time-blocks.date-in-existing-disabled-window',
    defaultMessage: 'Date is already in an existing closure, please choose another date',
  },
  datesOverlapExistingDisabledWindow: {
    id: 'venue-page.disabled-time-blocks.date-overlaps-existing-disabled-window',
    defaultMessage: 'Selected dates overlap an existing closure, please choose another window',
  },
  startTimeAfterEndTime: {
    id: 'venue-page.disabled-time-blocks.start-time-after-end-time',
    defaultMessage: 'Start date must be before end date',
  },
  endTimeBeforeStartTime: {
    id: 'venue-page.disabled-time-blocks.end-time-before-start-time',
    defaultMessage: 'End date must be after start date',
  },
  dateInPastOrMaxBound: {
    id: 'venue-page.disabled-time-blocks.max-end-date-error',
    defaultMessage:
      'Check to ensure your end date isn’t before your start date or your total closure duration isn’t longer than 14 days',
  },
  closureDurationAtMax: {
    id: 'venue-page.disabled-time-blocks.max-closure-duration',
    defaultMessage:
      'You have reached the maximum closure duration of 14 days. Please <a>Contact us</a> if you need to close your business for longer than 14 days.',
  },
});

export const deleteConfirmationMessages = defineMessages({
  title: {
    id: 'venue-page.delete-disabled-time-window-confirm.title',
    defaultMessage: "Are you sure you'd like to remove this time block?",
  },
  body: {
    id: 'venue-page.delete-disabled-time-window-confirm.body',
    defaultMessage: 'Removing this time block will allow new reservations to be made.',
  },
  accept: {
    id: 'venue-page.delete-disabled-time-window-confirm.accept',
    defaultMessage: 'Confirm',
  },
  cancel: {
    id: 'venue-page.delete-disabled-time-window-confirm.cancel',
    defaultMessage: 'Cancel',
  },
});

export const createConfirmationMessages = defineMessages({
  title: {
    id: 'venue-page.create-disabled-time-window-confirm.title',
    defaultMessage:
      'You have {numReservations} confirmed {numReservations, plural, =1 {reservation} other {reservations}} during this time',
  },
  body: {
    id: 'venue-page.create-disabled-time-window-confirm.body',
    defaultMessage:
      'Are you sure you want to close your venue during this time period? Your reservations will be canceled and ClassPass members will be immediately notified.',
  },
  accept: {
    id: 'venue-page.create-disabled-time-window-confirm.accept',
    defaultMessage: 'Confirm',
  },
  cancel: {
    id: 'venue-page.create-disabled-time-window-confirm.cancel',
    defaultMessage: 'Cancel',
  },
});

export const successMessages = defineMessages({
  title: {
    id: 'venue-page.success-disabled-time-window.title',
    defaultMessage: 'Closure dates added',
  },
  body: {
    id: 'venue-page.success-disabled-time-window.body',
    defaultMessage: `Time block successfully created. This may take up to a half an hour to reflect in your venue's availability to ClassPass members`,
  },
  accept: {
    id: 'venue-page.success-disabled-time-window.accept',
    defaultMessage: 'Got it',
  },
});
